/* dashboard-rediseno (15-oct-2026): EL CHIP DE ESTADO DEL PANEL.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Componente nuevo "Chip de estado" del documento: 22 px de alto, radio completo, 12 px
   seminegrita, icono de 12. Cuatro tonos:
     neutro   fondo #1F1F1F, borde #2C2C2C, texto #D4D4D4 (Procesando, con su giro);
     gris     #181818, #262626, #9A9A9A (En fila, con su reloj);
     naranja  #241710, #3A2414, #F7A06A (va lento, listo para procesar, parcial);
     rojo     #2A1414, #4A1F1F, #F87171 (fallo, con su triangulo).
   Los colores van en linea: son del documento y no estrenan clases. */
import React from 'react';
import { AlertTriangle, Clock, Loader2 } from 'lucide-react';

export const TONOS_DEL_CHIP = {
  neutro: { fondo: '#1F1F1F', borde: '#2C2C2C', texto: '#D4D4D4' },
  gris: { fondo: '#181818', borde: '#262626', texto: '#9A9A9A' },
  naranja: { fondo: '#241710', borde: '#3A2414', texto: '#F7A06A' },
  rojo: { fondo: '#2A1414', borde: '#4A1F1F', texto: '#F87171' },
};

const ICONOS = { giro: Loader2, reloj: Clock, triangulo: AlertTriangle };

// `titulo` (segunda vuelta, D9): el texto entero al posarse, para el chip que se corta con "...".
export default function ChipDeEstado({ tono = 'neutro', icono = null, children, testid, className = '', titulo }) {
  const c = TONOS_DEL_CHIP[tono] || TONOS_DEL_CHIP.neutro;
  const Icono = icono ? ICONOS[icono] : null;
  return (
    <span
      className={`inline-flex items-center gap-1 h-[22px] px-2 rounded-full border text-[12px] leading-none font-semibold whitespace-nowrap ${className}`}
      style={{ backgroundColor: c.fondo, borderColor: c.borde, color: c.texto }}
      data-testid={testid}
      data-tono={tono}
      title={titulo}
    >
      {Icono ? <Icono className={`w-3 h-3 shrink-0${icono === 'giro' ? ' animate-spin' : ''}`} aria-hidden="true" /> : null}
      <span className="truncate">{children}</span>
    </span>
  );
}
